export default () => {
let file = `
module.exports = {
    npm: []
}
`

    return file
}